import Cookies from 'js-cookie';

export const setCookie = (key, value) => {
	Cookies.set(key, value);
};

export const getCookie = key => {
	return Cookies.get(key);
};

export const getCookieAsJson = key => {
	try {
		return Cookies.getJSON(key);
	} catch (error) {
		return null;
	}
};

export const removeCookie = key => {
	try {
		Cookies.remove(key);
		return { success: true };
	} catch (error) {
		console.log("REMOVE_COOKIE[error] = " + error?.message);
		return { success: false, message: error.message };
	}
};